import React from "react";
import RPMCarePlanForm from './RPMCarePlanForm';
import logoImage from "../../../files/smarthealth.jpg";
import { Row, Col } from "reactstrap";
import moment from "moment";

const RPMCarePlanPrint = React.forwardRef(({ formData, rpmMedicalNecessityConfig: propRpmMedicalNecessityConfig }, ref) => {
  
  React.useEffect(() => {
    document.title = "RPM Care Plan Report";
  }, []);

  const displayData = formData || {};
  const rpmMedicalNecessityConfig = propRpmMedicalNecessityConfig || displayData.rpmMedicalNecessityConfig || displayData.rpmMedicalNecessity || [];    
  
  const styles = {
    container: {
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      lineHeight: '1.6',
      color: '#000000'
    },
    header: {
      background: 'linear-gradient(to right, #007fad 0%, #02a2ce 50%, #00bbe6 100%)',
      borderRadius: '8px',
      padding: '25px 20px',
      marginBottom: '25px',
      boxShadow: '0 2px 10px #5ac9eb',
      position: 'relative'
    },
    logo: {
      width: '200px',
      marginBottom: '10px',
      filter: 'brightness(0) invert(1)'
    },
    title: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#ffffff',
      margin: '10px 0',
      textShadow: '0 1px 2px rgba(0,0,0,0.3)'
    },
    subtitle: {
      fontSize: '18px',
      color: 'rgba(255, 255, 255, 0.9)',
      marginTop: '8px',
      fontWeight: '500'
    },
    dateInfo: {
      display: 'flex',
      justifyContent: 'center',
      gap: '15px',
      fontWeight: '500',
      marginTop: '14px',
      flexWrap: 'wrap'
    },
    dateItem: {
      background: '#007fad',
      padding: '6px 14px',
      fontWeight: '500',
      borderRadius: '15px',
      color: '#ffffff',
      fontSize: '14px',
      fontWeight: '500'
    },
    divider: {
      height: '3px',
      background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0) 100%)',
      margin: '15px 0'
    }
  };

  // Get current date for display
  const currentDate = moment().format('MMMM DD, YYYY');
  const currentTime = moment().format('h:mm A');

  return (
    <div ref={ref} style={styles.container}>
      {/* Header with Logo */}
      <div style={styles.header}>
        <div className="text-center">
            <img
              src={logoImage}
              alt="MyVitalview"
              style={styles.logo}
            />
          </div>
          <div style={styles.title}>RPM Care Plan Report</div>
          <div style={styles.subtitle}>Remote Patient Monitoring Care Plan Details</div>
          <div style={styles.divider}></div>
          <div style={styles.dateInfo}>
            <span style={styles.dateItem}>
              <i className="mdi mdi-file-document-outline" style={{ marginRight: '5px' }}></i>
              Generated Report
            </span>
            <span style={styles.dateItem}>
              <i className="mdi mdi-calendar" style={{ marginRight: '5px' }}></i>
              {currentDate}
            </span>
            <span style={styles.dateItem}>
              <i className="mdi mdi-clock-outline" style={{ marginRight: '5px' }}></i>
              {currentTime}
            </span>
          </div>
      </div>

      {/* Use the common RPMCarePlanForm component */}
      <RPMCarePlanForm
        formData={displayData}
        onInputChange={() => { }}
        onSubmit={() => { }}
        isEditing={false}
        showButtons={false}
        isViewMode={true}
        conditionNames={displayData.conditionNames || []}
        rpmMedicalNecessityConfig={rpmMedicalNecessityConfig}
      />
    </div>
  );
});

export default RPMCarePlanPrint;
